export const TIME_UNITS = [
    {
        value: "SECONDS",
        label: "Seconds",
    },
    {
        value: "MINUTES",
        label: "Minutes",
    },
    {
        value: "HOURS",
        label: "Hours",
    },
    {
        value: "DAYS",
        label: "Days",
    },
    {
        value: "WEEKS",
        label: "Weeks",
    },
    {
        value: "MONTHS",
        label: "Months",
    },
    {
        value: "YEARS",
        label: "Years",
    },
];
